import { PropsWithChildren, ReactNode } from 'react';

import { cx } from '@emotion/css';
import { Flex } from '@revenuemarket/cds';
import { PrimaryColors, theme } from '@revenuemarket/design';
import { Convert } from '@revenuemarket/react';

import { css } from '~libs/emotion';

interface Props {
  active?: boolean;
  border?: boolean;
  icon?: ReactNode;
  rightSlot?: ReactNode;
  onClick?: () => void;
  borderRadius?: number;
}

const Chip = ({
  children,
  active,
  border,
  icon,
  onClick,
  rightSlot,
  borderRadius,
}: PropsWithChildren<Props>) => {
  return (
    <Flex
      onClick={() => onClick?.()}
      className={cx(
        css`
          flex-shrink: 0;
          padding: 2px 8px;
          border-radius: ${borderRadius ?? 16}px;
          background-color: ${theme.colorTokens.bgDefault};
          border: 1px solid transparent;
          box-sizing: border-box;
        `,
        border &&
          css`
            border: 1px solid ${theme.colorTokens.borderDefault};
          `,
        active &&
          css`
            border: 1px solid ${PrimaryColors.primary700};
            background-color: ${PrimaryColors.primary50};
          `,
        onClick != null &&
          css`
            cursor: pointer;
          `,
        icon != null &&
          css`
            padding: 2px 8px 2px 4px;
          `,
      )}
    >
      <Flex
        gap={8}
        align="center"
        className={css`
          width: 100%;
        `}
      >
        {icon}
        <Flex justify="space-between" align="center" gap={8}>
          {children}
          <Convert value={rightSlot} expression={(rightSlot) => <Flex>{rightSlot}</Flex>} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Chip;
